import * as React from "react";
import { UserEntity } from "../../../../application/domain/user/user-entity";
import { useUserBasicInfo } from "./use-user-basic-info";
import { Group } from "../../../../application/domain/group/group";
import { User } from "../../../../application/domain/user/user";
import { UserEdit } from "./edit";
import { UserView } from "./view";
import { useAuthContextV2 } from "../../../../auth-state";

export type UserBasicInfoProps = {
  user: UserEntity;
  groups: Group[];
  orgId?: string;
  fetchUser: () => Promise<void>;
  fetchGroupCandidates: (name: string) => Promise<Group[]>;
  updateUser: (user: User) => Promise<boolean>;
  isServiceProvider: boolean;
};

export const UserBasicInfo: React.FC<UserBasicInfoProps> = ({
  user,
  groups,
  fetchUser,
  fetchGroupCandidates,
  updateUser,
  isServiceProvider,
}) => {
  const {
    inputUserInfo,
    setInputUserInfo,
    isEdit,
    setIsEdit,
    shouldSelectGroup,
    validationError,
    isValidationError,
  } = useUserBasicInfo({
    user,
    groups,
    fetchGroupCandidates,
  });
  const { auth } = useAuthContextV2();

  if (isEdit) {
    return (
      <UserEdit
        inputUserInfo={inputUserInfo}
        setIsEdit={setIsEdit}
        setInputUserInfo={setInputUserInfo}
        fetchUser={fetchUser}
        updateUser={updateUser}
        validationError={validationError}
        shouldSelectGroup={shouldSelectGroup}
        isValidationError={isValidationError}
        isServiceProvider={isServiceProvider}
        isSamlAuthEnabled={auth.data?.orgUsingFeature.useSamlAuth ?? false}
      />
    );
  } else {
    return (
      <UserView
        user={user}
        setIsEdit={setIsEdit}
        groups={groups}
        shouldSelectGroup={shouldSelectGroup}
        isSamlAuthEnabled={auth.data?.orgUsingFeature.useSamlAuth ?? false}
      />
    );
  }
};
